module.exports = __webpack_public_path__ + "media/meditation_2.790a6b02.mp4";